import { useState, useEffect } from 'react';
import InputLabel from 'raydiant-elements/core/InputLabel';
import ColorField from 'raydiant-elements/core/ColorField';
import { useTheme } from 'raydiant-elements/styles';
import Text from 'raydiant-elements/core/Text';
import {
  getPropertyBackgroundColor,
  setPropertyBackgroundColor,
} from '../../utilities/properties';
import { useApplicationFormContext } from '../../hooks/useApplicationForm';

const ApplicationInputBackgroundColor = () => {
  const {
    isEditable,
    version,
    selectedProperty,
    updateSelectedProperty,
  } = useApplicationFormContext();

  const theme = useTheme();

  // State

  const [backgroundColor, setBackgroundColor] = useState(
    selectedProperty ? getPropertyBackgroundColor(selectedProperty) : '',
  );

  // Callbacks

  const onClose = () => {
    if (!selectedProperty) return;
    if (!version) return;
    if (!backgroundColor) return;

    updateSelectedProperty(
      setPropertyBackgroundColor(selectedProperty, backgroundColor),
      version.strings,
    );
  };

  // Effects

  // Set background color when property changes.
  useEffect(() => {
    setBackgroundColor(
      selectedProperty ? getPropertyBackgroundColor(selectedProperty) : '',
    );
  }, [selectedProperty]);

  // Render

  return (
    <div>
      {isEditable && (
        <ColorField
          label="Background Color"
          value={backgroundColor || theme.palette.primary.main}
          onChange={setBackgroundColor}
          onClose={onClose}
        />
      )}

      {!isEditable && selectedProperty && (
        <>
          <InputLabel>Background Color</InputLabel>
          <Text>
            {getPropertyBackgroundColor(selectedProperty) || <em>None</em>}
          </Text>
        </>
      )}
    </div>
  );
};

export default ApplicationInputBackgroundColor;
